// Polyfill crypto.randomUUID for non-secure contexts (HTTP on mobile devices)
if (typeof crypto !== 'undefined' && !crypto.randomUUID) {
  crypto.randomUUID = () =>
    '10000000-1000-4000-8000-100000000000'.replace(/[018]/g, c =>
      (+c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> +c / 4).toString(16)
    );
}

import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './index.css';
import './firebase-config';
import { ThemeProvider } from './contexts/ThemeContext';
import { AuthProvider } from './contexts/AuthContext';
import { ProjectProvider } from './contexts/ProjectContext';
import { PageProvider } from './contexts/PageContext';
import './utils/buildInfo';
import { initializeCookiebot } from './privacy/cookiebot.js';

// Cookiebot owns consent policy, geography, persistence, UI, and Consent Mode
// updates. The app stays in manual blocking mode and will not load any
// analytics or marketing tag until the provider reports a ready grant.
initializeCookiebot();

// Brand title. Previously set as a side effect of the retired ProductContext
// provider (hostname/port -> legacy tier detection). Kept verbatim here so the
// browser tab reads the same as it did before that provider was removed.
document.title = 'ADU Lab';

ReactDOM.createRoot(document.getElementById('root')).render(
  <ThemeProvider>
    <AuthProvider>
      <ProjectProvider>
        <PageProvider>
          <App />
        </PageProvider>
      </ProjectProvider>
    </AuthProvider>
  </ThemeProvider>
);
